<template>
  <div id="banner" v-html="strings">
    

  </div>
</template>


<script>
    export default {
        data() {
            return {
                swiperOption: {
                    //显示分页
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    //设置点击箭头
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    //自动轮播
                    autoplay: {
                        delay: 3000,
                        //当用户滑动图片后继续自动轮播
                        disableOnInteraction: false,
                    },
                    //开启循环模式
                    loop: true
                },
                http:'',//域名拼接


            }
        },
      created() {
        let that = this;
        that.http = that.$publicUrl.http1;

        // that.getFriend();
      },
        props: {
            carouselArr: {
                type: Array
            },

            strings: {
              // type: Array,
              default () {
                return '';
              }
            }
        }
    }
</script>

<style scoped>
    #banner {
        width: 100%;
        min-height: 240px;
        position: relative;
    }

    .v_bannersize {
        max-width: 100%;
        display: block;
        height: 480px;
        object-fit: cover;
        margin: 0 auto;
    }

    .v_bannerhot {
        width: 1200px;
        position: relative;
        display: block;
        margin: 0 auto;
    }

    .v_bannerhotright {
        width: 220px;
        height: 540px;
        position: absolute;
        top: 0;
        right: 0px;
        z-index: 10;
        overflow: hidden;
    }

    .v_bannerhotrightson {
        width: 220px;
        height: 240px;
        margin-top: 20px;
        display: block;
        border: 5px solid #ffffff;
        box-sizing: border-box;
    }

    .v_bannerhotrightson img {
        max-width: 100%;
        height: 100%;
        display: block;
        /*height: 240px;*/
        object-fit: cover;
    }
</style>
